import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const RunComingIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M13.5 5.5C14.59 5.5 15.5 4.58 15.5 3.5C15.5 2.96957 15.2893 2.46086 14.9142 2.08579C14.5392 1.71071 14.0304 1.5 13.5 1.5C12.39 1.5 11.5 2.38 11.5 3.5C11.5 4.58 12.39 5.5 13.5 5.5ZM9.89001 19.38L10.89 15L13 17V23H15V15.5L12.89 13.5L13.5 10.5C14.1848 11.2856 15.0301 11.9153 15.9788 12.3466C16.9276 12.7778 17.9578 13.0006 19 13V11C17.09 11 15.5 10 14.69 8.58L13.69 7C13.29 6.38 12.69 6 12 6C11.69 6 11.5 6.08 11.19 6.08L6.00001 8.28V13H8.00001V9.58L9.79001 8.88L8.19001 17L3.29001 16L2.89001 18L9.89001 19.38Z'
                fill='currentColor'
            />
        </>
    ),
})

RunComingIcon.displayName = 'RunComingIcon'
